import '../../../scss/hotfood/components/hotfood-fable.scss'

import { Body1, Button, ButtonGroup, Modal } from '@sainsburys-tech/fable'
import React from 'react'

interface IProps {
  handleClose: () => void
  handleSave: () => void
  isOpen: boolean
}

const DeleteBatchModal = (props: IProps) => (
  <Modal
    size='sm'
    onClose={() => props.handleClose()}
    isOpen={props.isOpen}
    testid='info-modal'
    header={{ label: 'Delete batch' }}
    contentHeight={'fit'}
    renderFooter={
      <ButtonGroup orientation={'horizontal'}>
        <Button
          className='hotfood-full-width'
          onClick={() => props.handleSave()}
          testid='yes-button'
          variant='secondary'
          style={{
            backgroundColor:
              'var(--fable-color-background-secondary-default, #ffffff)',
          }}
        >
          Yes
        </Button>
        <Button
          className='hotfood-full-width'
          onClick={() => props.handleClose()}
          testid='no-button'
        >
          No
        </Button>
      </ButtonGroup>
    }
  >
    <>
      <Body1 style={{ textAlign: 'center' }}>
        Are you sure you would like to delete this batch?
      </Body1>
    </>
  </Modal>
)

export default DeleteBatchModal
